





















import {Component, Prop, Vue} from 'vue-property-decorator';
import AnnouncementForm from "@/forms/AnnouncementForm.vue";

@Component({
    components: {
        AnnouncementForm
    },
    name: "EditAnnouncement"
})
export default class EditAnnouncement extends Vue {
    @Prop(String) readonly announcementUuid!: string;

}

